import { FETCH_TYPEAHEAD_POSIZIONI_PROFESSIONALI } from '../actions/types';

const INITIAL_STATE = [];

export default function(state = INITIAL_STATE, action) {
	switch(action.type) {
		case FETCH_TYPEAHEAD_POSIZIONI_PROFESSIONALI:
			return action.payload.data || [];
		default:
			return state;
	}
}
